/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { IceTypes } from '../../models/icetypes';
import { IceEntity } from '../../models/core/IceEntity';

export class alertsummary extends IceEntity {
  glkey: string = "";
  gltype: IceTypes.guidelinetype.gdetypeDisease;
  alert_type: IceTypes.ALERTTYPE.alertDiseaseManagement;
  severity_type: IceTypes.severitytype.servTypeCritical;
  details: string = "";

  gettablename(): string {
    return "ALERT_SUMMARY";
  }
}

export class cpt_contraindication extends alertsummary { gettablename(): string { return "CPT_ContraIndication"; } }
export class cpt_interaction extends alertsummary { gettablename(): string { return "CPT_Interaction"; } }
export class cpt_synonym extends alertsummary { gettablename(): string { return "CPT_Synonym"; } }
export class cpt_required extends alertsummary { gettablename(): string { return "CPT_Required"; } }

export class ndc_contraindication extends alertsummary { gettablename(): string { return "NDC_ContraIndication"; } }
export class ndc_interaction extends alertsummary { gettablename(): string { return "NDC_Interaction"; } }
export class ndc_synonym extends alertsummary { gettablename(): string { return "NDC_Synonym"; } }
export class ndc_required extends alertsummary { gettablename(): string { return "NDC_Required"; } }

export class diag_contraindication extends alertsummary { gettablename(): string { return "Diag_ContraIndication"; } }
export class diag_interaction extends alertsummary { gettablename(): string { return "Diag_Interaction"; } }
export class diag_synonym extends alertsummary { gettablename(): string { return "Diag_Synonym"; } }
export class diag_required extends alertsummary { gettablename(): string { return "Diag_Required"; } }

export class allergy_interaction extends alertsummary { gettablename(): string { return "Allergy_Interaction"; } }

export class limitsummary extends alertsummary { gettablename(): string { return "LimitSummary"; } }
export class surveysummary extends alertsummary { gettablename(): string { return "SurveySummary"; } }

export class resultinformation extends alertsummary {
  reportkey: string = "";

  gettablename(): string  { return "RESULT_INFORMATION"; }
}

export class coderesult extends resultinformation {
  code: string = "";
  title: string = "";
  with_code: string = "";
  with_key: string = "";
  with_title: string = "";

  gettablename(): string { return "CodeResult"; }
}

export class limitandsurveyresult extends resultinformation {
  code: string = "";
  value: number = 0.0;
  typeofrange: IceTypes.TYPEOFRANGE.torInside;
  lower: number = 0.0;
  upper: number = 0.0;
  units: string = "";
  dateofvalue: any = NaN;
  description: string = "";

  gettablename(): string { return "LimitAndSurveyResult"; }

}

export class resultsummary extends IceEntity {
  srctype: IceTypes.SourceType.srcUndefined;
  srckey: string = "";

  DETAILS: resultinformation[] = [];

  gettablename(): string { return "Result"; }

  public hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "DETAILS") return true;

    return false;
  }

  public getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "DETAILS") return "RESULT_INFORMATION,CodeResult,LimitAndSurveyResult";

    return null;
  }
}

enum AlertSummaryType {
  Unknown = 0,
  CPT_ContraIndication = 11,
  CPT_Interaction = 12,
  CPT_Synonym = 13,
  CPT_Required = 14,

  Diag_ContraIndication = 21,
  Diag_Interaction = 22,
  Diag_Synonym = 23,
  Diag_Required = 24,

  NDC_ContraIndication = 31,
  NDC_Interaction = 32,
  NDC_Synonym = 33,
  NDC_Required = 34,

  Allergy_Interaction = 41,

  Limits = 51,

  Surveys = 61,

  Results = 71,
}

export class guidelinesummary extends IceEntity
{
  code: string = "";
  srctype: IceTypes.SourceType.srcUndefined;
  srckey: string = "";
  gltype: IceTypes.guidelinetype.gdetypeDisease;
  default_alerttype: IceTypes.ALERTTYPE.alertDiseaseManagement;

  ALERT_SUMMARIES: alertsummary[] = [];
  CPTContraIndications: cpt_contraindication[] = [];
  NDCContraIndications: ndc_contraindication[] = [];
  DiagContraIndications: diag_contraindication[] = [];

  CPTInteractions: cpt_interaction[] = [];
  NDCInteractions: ndc_interaction[] = [];
  DiagInteractions: diag_interaction[] = [];

  AllergyInteractions: allergy_interaction[] = [];

  CPTSynonyms: cpt_synonym[] = [];
  NDCSynonyms: ndc_synonym[] = [];
  DiagSynonyms: diag_synonym[] = [];

  CPTRequired: cpt_required[] = [];
  NDCRequired: ndc_required[] = [];
  DiagRequired: diag_required[] = [];

  LimitSummaries: limitsummary[] = [];
  SurveySummaries: surveysummary[] = [];
  Results: resultsummary[] = [];
  
  gettablename(): string { return "GUIDELINE_SUMMARY"; }

  public hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "ALERT_SUMMARIES") return true;
    else if (ColumnName == "CPTContraIndications") return true;
    else if (ColumnName == "CPTInteractions") return true;
    else if (ColumnName == "CPTSynonyms") return true;
    else if (ColumnName == "CPTRequired") return true;
    else if (ColumnName == "NDCContraIndications") return true;
    else if (ColumnName == "NDCInteractions") return true;
    else if (ColumnName == "NDCSynonyms") return true;
    else if (ColumnName == "NDCRequired") return true;
    else if (ColumnName == "DiagContraIndications") return true;
    else if (ColumnName == "DiagInteractions") return true;
    else if (ColumnName == "DiagSynonyms") return true;
    else if (ColumnName == "DiagRequired") return true;
    else if (ColumnName == "AllergyInteractions") return true;
    else if (ColumnName == "LimitSummaries") return true;
    else if (ColumnName == "SurveySummaries") return true;
    else if (ColumnName == "Results") return true;

    return false;
  }

  public getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "ALERT_SUMMARIES") return "ALERT_SUMMARY";
    else if (ColumnName == "CPTContraIndications") return "CPT_ContraIndication";
    else if (ColumnName == "CPTInteractions") return "CPT_Interaction";
    else if (ColumnName == "CPTSynonyms") return "CPT_Synonym";
    else if (ColumnName == "CPTRequired") return "CPT_Required";
    else if (ColumnName == "NDCContraIndications") return "NDC_ContraIndication";
    else if (ColumnName == "NDCInteractions") return "NDC_Interaction";
    else if (ColumnName == "NDCSynonyms") return "NDC_Synonym";
    else if (ColumnName == "NDCRequired") return "NDC_Required";
    else if (ColumnName == "DiagContraIndications") return "Diag_ContraIndication";
    else if (ColumnName == "DiagInteractions") return "Diag_Interaction";
    else if (ColumnName == "DiagSynonyms") return "Diag_Synonym";
    else if (ColumnName == "DiagRequired") return "Diag_Required";
    else if (ColumnName == "AllergyInteractions") return "Allergy_Interaction";
    else if (ColumnName == "LimitSummaries") return "LimitSummary";
    else if (ColumnName == "SurveySummaries") return "SurveySummary";
    else if (ColumnName == "Results") return "Result";

    return null;
  }
}
